import "core-js/modules/es.array.push.js";
import I18nHelper from '../../myAccount/helper/i18n-helper.js';
import { Tooltip } from '../../blocks/output-elements/tooltip';
import CheckoutPending from '@/dow-platform/components/commerce/blocks/svg-elements/checkout-pending/CheckoutPending.vue';
import CheckoutConfirm from '@/dow-platform/components/commerce/blocks/svg-elements/checkout-confirm/CheckoutConfirm.vue';
export default {
  name: 'ConfirmationPage',
  components: {
    Tooltip,
    CheckoutPending,
    CheckoutConfirm
  },
  created() {
    this.confirmationData = this.$store.getters['cart/getConfirmationData'];
    if (this.confirmationData === null || Object.keys(this.confirmationData).length === 0) {
      this.redirectToMyOrders();
      return;
    }
    this.loading = false;
  },
  data() {
    return {
      confirmationData: null,
      orderLink: 'my-account.html#/my-orders/order-details/',
      ordersLink: 'my-account.html#/my-orders',
      reOrderText: I18nHelper.getI18nMessage('order.detail.rightRail.reorder'),
      orderText: I18nHelper.getI18nMessage('order.confirmation.button.view.status'),
      loading: true
    };
  },
  computed: {
    hasConfirmationData() {
      return this.confirmationData != null;
    },
    hasReturnedLineItems() {
      return this.confirmationData?.returnedLineItems?.length > 0;
    },
    confirmationData() {
      return this.$store.getters['cart/getConfirmationData'];
    },
    orders() {
      return this.confirmationData?.orderCarts;
    },
    hasErrorDetails() {
      return this.confirmationData?.errorDetails && Object.keys(this.confirmationData.errorDetails).length > 0;
    }
  },
  methods: {
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    getFormattedTotal: function (order) {
      return `${order.formatTotalAmount} ${order.totalAmountCurrency}`;
    },
    ifValueExists: function (value) {
      return value !== undefined && value !== null && value !== '';
    },
    getMaterialNumberLabel: function (value) {
      let label = window.Granite.I18n.get('cart.page.line.item.materialNumber');
      return label.replace('{0}', value);
    },
    viewOrders: function () {
      this.redirectToMyOrders();
    },
    reOrder: function () {
      this.confirmationPageReorderTracking();
      var products = localStorage.getItem('productList');
      products = JSON.parse(products);
      products = products.map(obj => ({
        ...obj,
        isFromReorder: true
      }));
      localStorage.setItem('productList', JSON.stringify(products));
      window.location.href = 'quick-order.html';
    },
    confirmationPageReorderTracking: function () {
      var product = localStorage.getItem("productList");
      product = JSON.parse(product);
      var productList = [];
      for (let i = 0; i < product.length; i++) {
        productList.push({
          SKU: product[i].SKU || 'unavailable',
          gmid: product[i].gmid || 'unavailable',
          productAddMethod: "Re-Order",
          name: product[i].name
        });
      }
      this.$store.dispatch('pdp/addToCartTracking', {
        step: 'step1',
        products: productList
      });
    },
    redirectToMyOrders() {
      window.location.href = this.ordersLink;
    }
  }
};